import {useQuery} from 'react-query';
import {fetchStats} from '../api/reportsApi';

export function useStats(token, timeRange, date = null) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    return useQuery({
        queryKey: ['stats', timeRange, timezone, date, token],
        queryFn: () => fetchStats(token, timeRange, timezone, date),
        enabled: !!token && !!timeRange,
    });
}
